import React, {useEffect, useState} from "react";
import BackBtn from "../components/BackBtn";
import VehicleFeatures from "../components/VehFeatures";
import { useSelectedVehicle } from "../context/vehicle.context";
import { useUser } from "../context/user.context";
import VehicleList from "../components/VehList";
import { VehicleInformation } from "../data/VehInfo";
import VehSelectPopup from "../components/VehSelectPopup";
import UserDetails from  "../components/UserDetailsForm.jsx";

const VehicleSelect = (options)=>{
    const { selVehData, setSelVehData } = useSelectedVehicle();
    const { userData, setUserData } = useUser();

    useEffect(()=>{
        if(!userData.isComplete()){
            // alert("Please complete user details before selecting a vehicle.");
            // window.location.href = "/";
        }
    }, [userData]);

    const vehData = null
    const [data, setData] = useState(vehData);

    const cardClick = (vehKey)=>{
        console.log("Selected Vehicle: ", vehKey);
        setSelVehData({
            ...selVehData,
            vehKey: vehKey,
            selectingVariant: true
        });
    }

    return (
        <div className="page vehicleSelectPage">
            <h2 className="page-title">Select Vehicle</h2>
            <BackBtn url="/"/>
            <VehicleList onSelect={cardClick} />
            {selVehData.vehKey && <VehSelectPopup />}
            {!userData.isComplete() && <UserDetails UserDetails={userData} onSubmit={setUserData} />}
        </div>
    )
}

export default VehicleSelect;